import { getStringFromEnvParser, validateConfig } from "typed-env-parser";

export const ENV = validateConfig({
  REACT_APP_API_URL: getStringFromEnvParser("REACT_APP_API_URL"),
});
